import { Request } from './clientHelper';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL_CREATE;

export class UserActivityService {
	static sessionStart(payload) {
		const uri = API_BASE_URL + '/useractivity/session/start';
		return Request(uri, {
			method: 'POST',
			payload: payload.payload || {},
			headers: {
				appId: payload.appId
			}
		});
	}

	static sessionEnd(payload) {
		const uri = API_BASE_URL + '/useractivity/session/end';
		return Request(uri, {
			method: 'POST',
			payload: payload.payload || {},
			headers: {
				appId: payload.appId
			}
		});
	}

	static pageSessionStart(payload) {
		const uri = API_BASE_URL + '/useractivity/page/start';
		return Request(uri, {
			method: 'POST',
			payload: payload.payload || {},
			headers: {
				appId: payload.appId
			}
		});
	}

	static userActivityRecordEvent(payload) {
		const uri = API_BASE_URL + '/useractivity/page/event';
		return Request(uri, {
			method: 'POST',
			payload: payload.payload || {},
			headers: {
				appId: payload.appId
			}
		});
	}

	static getTotalSessions(payload) {
		const days = payload?.days != null ? payload.days : 7;
		const uri = `${API_BASE_URL}/useractivity/total-sessions?days=${days}`;
		return Request(uri, {
			method: 'GET',
			headers: { appId: payload?.appId }
		});
	}

	static getActiveUsers(payload) {
		const uri = API_BASE_URL + '/useractivity/active-users';
		return Request(uri, {
			method: 'GET',
			headers: { appId: payload?.appId }
		});
	}

	static getAvgSessionDuration(payload) {
		const days = payload?.days != null ? payload.days : 7;
		const uri = `${API_BASE_URL}/useractivity/avg-session-duration?days=${days}`;
		return Request(uri, {
			method: 'GET',
			headers: { appId: payload?.appId }
		});
	}

	static getTotalActions(payload) {
		const days = payload?.days != null ? payload.days : 7;
		const uri = `${API_BASE_URL}/useractivity/total-actions?days=${days}`;
		return Request(uri, {
			method: 'GET',
			headers: { appId: payload?.appId }
		});
	}

	static getSessionMembers(payload) {
		const days = payload?.days != null ? payload.days : 7;
		const uri = `${API_BASE_URL}/useractivity/sessions/members?days=${days}`;
		return Request(uri, {
			method: 'GET',
			headers: { appId: payload?.appId }
		});
	}

	static getSessions(payload) {
		const uri = `${API_BASE_URL}/useractivity/sessions`;
		const body = {
			days: payload?.days != null ? payload.days : 7,
			memberIds: Array.isArray(payload?.memberIds) ? payload.memberIds : undefined,
			page: payload?.page != null ? payload.page : 1,
			pageSize: payload?.pageSize != null ? payload.pageSize : 20
		};
		return Request(uri, {
			method: 'POST',
			payload: body,
			headers: { appId: payload?.appId }
		});
	}

	static getSessionDetails(payload) {
		const sessionId = payload?.sessionId;
		if (!sessionId) return Promise.reject(new Error('sessionId required'));
		const uri = `${API_BASE_URL}/useractivity/sessions/${sessionId}/details`;
		return Request(uri, {
			method: 'GET',
			headers: { appId: payload?.appId }
		});
	}
}
